export const website = {
  title: "Title",
  url: "URL",
  description: "Description",
  mainCategory: "Main Category",
  subCategory: "Subcategory",
  region: "Region",
  zipCode: "Zip Code",
  addedBy: "Added by",
  addedAt: "Added at",
  suggestedBy: "Suggested by",
  suggestedAt: "Suggested at",
  status: "Status",
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
};

export const suggestWebsite = {
  title: "Suggest Website",
  subtitle: "Suggest a German website for the archive",
  form: {
    websiteTitle: "Website Title",
    websiteTitlePlaceholder: "e.g. Federal Ministry of Education and Research",
    websiteUrl: "Website URL",
    websiteUrlPlaceholder: "e.g. bmbf.de or https://www.bmbf.de",
    description: "Description",
    descriptionPlaceholder: "Brief description of the website and its purpose",
    selectMainCategory: "Select main category",
    selectSubCategory: "Select subcategory",
    region: "Region/State",
    regionPlaceholder: "e.g. Bavaria, North Rhine-Westphalia",
    zipCode: "Zip Code (from legal notice)",
    zipCodePlaceholder: "e.g. 10115",
  },
  button: "Suggest Website",
  success: "Website suggested successfully",
  successDescription:
    "Your website suggestion will be reviewed by our curators.",
};

export const addWebsite = {
  title: "Add Website",
  subtitle: "Add a new website to the archive",
  button: "Add Website",
  success: "Website added successfully",
  successDescription: "The website has been added to the archive.",
};

export const editWebsite = {
  title: "Edit Website",
  button: "Save Changes",
  success: "Website updated successfully",
};

export const manageWebsites = {
  title: "Manage Websites",
  subtitle: "Manage your added websites",
  addNew: "New Website",
  myWebsites: "My Websites",
  suggestions: "Website Suggestions",
  searchPlaceholder: "Search websites...",
  noWebsites: "No websites added yet",
  noWebsitesDescription: "Start by adding websites to the archive.",
  deleteConfirm: "Delete website",
  deleteDescription: "This action cannot be undone.",
  approve: "Approve",
  reject: "Reject",
};

export const websiteSuggest = {
  title: "Suggest Website",
  subtitle: "Suggest a website for the archive",
  infoAsRegistered:
    "As a registered user, you can submit suggestions for new websites.",
  infoAsAnonymous:
    "As an anonymous user, you can submit suggestions for new websites.",
  infoRegisteredCanAdd:
    'As a registered user, you can also add websites directly using the "Add Website" function in the "Manage" menu.',
  infoAnonymousReview:
    "Your suggestions will be reviewed by registered users and may be added.",
  websiteInfo: "Website Information",
  websiteInfoDesc:
    "Please provide all required information about the suggested website",
  titleLabel: "Website Title *",
  titlePlaceholder: "e.g. Max Planck Institute for Physics",
  urlLabel: "Website URL *",
  urlPlaceholder: "example.com, www.example.com or https://www.example.com",
  /**
   * Optional address field (Suggest Website form).
   * Used by WebsiteSuggest.tsx (i18n keys: websiteSuggest.addressLabel/addressPlaceholder).
   */
  addressLabel: "Address (optional)",
  addressPlaceholder: "e.g. Musterstraße 1, 94032 Passau",
  addressAutoPlaceholder:
    "Enter address, city, district, or state (Germany)",
  addressAutoHint:
    "Suggestions appear as you type. Select one to prefill the region. Searching without house numbers often works better.",
  addressAutoNoResults: "No matches found.",
  addressAutoUnavailable:
    "Automatic region assignment is currently unavailable. You can continue manually.",
  addressAutoDisabled:
    "Address autocomplete is disabled in system settings. You can continue manually.",
  loadingShort: "Loading",
  addressConfidenceExact: "Address confidently recognized",
  addressConfidencePartial: "Region recognized",
  addressConfidenceState: "State recognized",
  addressConfidenceAdminDistrict: "Administrative district recognized",
  addressConfidenceDistrict: "District recognized",
  addressConfidenceAmbiguous: "Multiple matches – please select",
  urlHint:
    "You can enter the URL in various formats (e.g. example.com, www.example.com)",
  descriptionLabel: "Short Description *",
  descriptionPlaceholder:
    "Briefly describe the content and purpose of the website...",
  charactersCount: "{count} / 500 characters",
  category1Label: "Category (optional)",
  category1Placeholder: "Select Category",
  categorySelected: "Category selected",
  clearManualCategory: "Clear selection",
  categoryPathPrefix: "Category:",
  categoryRootLabel: "All categories",
  categoryBrowseChildren: "Browse children",
  categoryNavigatorHint:
    "Select a category name to apply it. Use the arrow button on the right to open deeper levels.",

  noCategory1Found: "No Category1 found.",

  category1LoadFailed: "Category could not be loaded.",
  loading: "Loading...",
  reachedLeaf: "No deeper categories available at this level.",

  mainCategoryLabel: "Main Category (optional)",
  mainCategoryPlaceholder: "Search category...",
  subCategoryLabel: "Subcategory (optional)",
  subCategoryPlaceholder: "Search subcategory...",
  noCategoryFound: "No category found.",
  noSubcategoryFound: "No subcategory found.",
  selectedCategorization: "Selected Categorization:",
  zipCodeLabel: "Postal Code (optional)",
  zipCodePlaceholder: "e.g. 10115",
  zipCodeHint: "",
  regionLabel: "Region/State (optional)",
  regionPlaceholder: "e.g. Bavaria, North Rhine-Westphalia",
  regionHint: "",
  regionPathPrefix: "Region:",
  regionLoadFailed: "Regions could not be loaded.",
  noRegionFound: "No region found.",
  zipRegionMismatch: "Postal code does not match the selected state.",
  submitButton: "Submit Suggestion",
  cancel: "Cancel",
  fillAllFields: "Please fill in all required fields",
  // The following three keys are used for validation error messages in WebsiteSuggest.tsx.
  errorTitleRequired:
    "Title cannot be empty, otherwise the suggestion cannot be submitted.",
  errorUrlRequired:
    "URL cannot be empty, otherwise the suggestion cannot be submitted.",
  errorDescriptionRequired:
    "Description cannot be empty, otherwise the suggestion cannot be submitted.",

  // Length limit.
  errorDescriptionTooLong: "Description must be at most {max} characters.",
  errorTitleTooLong: "Title must be at most {max} characters.",
  errorUrlTooLong: "URL must be at most {max} characters.",
  errorAddressTooLong: "Address must be at most {max} characters.",
  errorZipTooLong: "Zip code must be at most {max} characters.",

  // URL error messages.
  errorUrlExists: "URL already exists.",
  errorUrlVerifyFailed: "Could not verify URL. Please try again.",
  successTitle: "Suggestion successfully submitted!",
  successMessage:
    "Your website suggestion has been successfully submitted and will now be reviewed by registered users.",
  website: "Website",
  url: "URL",
  category: "Category",
  unknown: "Unknown",
  done: "Done",
  back: "Back",
  clearSelection: "Clear selection",
  successRegisteredInfo:
    "You can view the status of your suggestions in the website management.",
  successAnonymousInfo:
    "Thank you for your contribution to the WebKurator.de archive!",
  understood: "Understood",
  goToManagement: "Go to Management",

  submitSuccess: "Suggestion submitted successfully.",
  submitError: "Failed to submit suggestion.",

  //AI button
  aiCategoryLabel: "AI-assisted category suggestion",
  aiSuggestButton: "Suggest with AI",
  aiSuggesting: "AI is suggesting...",
  aiClearButton: "Clear AI suggestion",
  aiApplied: "AI category suggestion applied successfully.",
  aiLockedHint: "The category was set by AI. You can clear it to select manually.",
  aiResultPrefix: "AI suggestion:",
  aiNeedTitleAndDescription: "Please enter title, URL, and description before AI categorization is available.",
  aiTimeout: "The AI service did not respond in time. Please try again later.",
  aiBadGateway: "The AI service is currently unavailable. Please try again later.",
  aiFailed: "AI category suggestion failed. Please try again.",
  geocodingBadGateway:
    "The address service is currently unavailable. Please try again later."
};

export const websiteManagement = {
  title: "Website Management",
  subtitle: "Add, edit websites and manage suggestions",
  tabAdd: "Add Website",
  tabManage: "Edit Websites",
  tabSuggestions: "Suggestions",
  addWebsiteTitle: "Add New Website",
  addWebsiteDesc: "Add a new website directly to the archive (without review)",
  titleLabel: "Website Title *",
  titlePlaceholder: "e.g. Max Planck Institute",
  urlLabel: "URL *",
  urlPlaceholder: "example.com, www.example.com or https://...",
  urlHint: "Various formats are accepted",
  descriptionLabel: "Description *",
  descriptionPlaceholder: "Website description...",
  mainCategoryLabel: "Main Category *",
  mainCategoryPlaceholder: "Search category...",
  subCategoryLabel: "Subcategory (optional)",
  subCategoryPlaceholder: "Search subcategory...",
  noCategoryFound: "No category found.",
  noSubcategoryFound: "No subcategory found.",
  zipCodeLabel: "Postal Code (optional)",
  zipCodePlaceholder: "e.g. 10115",
  zipCodeHint:
    "The region will be automatically determined from the postal code",
  zipRegionMismatch: "Postal code does not match the selected state.",
  addressLabel: "Address (optional)",
  regionLabel: "Region/State *",
  regionPlaceholder: "e.g. Bavaria, North Rhine-Westphalia",
  regionHint: "Automatically filled, but can be adjusted",
  addButton: "Add Website",
  cancel: "Cancel",
  fillAllFields: "Please fill in all required fields",
  categoryRequiredError: "Please select a category.",
  regionRequiredError: "Please select a region or enter a postal code.",
  manageWebsitesTitle: "Edit Websites",
  manageWebsitesDesc: "Edit or delete existing websites",
  searchPlaceholder: "Search websites...",
  filter: "Filter",
  tableTitle: "Title",
  tableCategory: "Category",
  tableLocation: "Location",
  tableAdded: "Added",
  tableActions: "Actions",
  editButton: "Edit",
  deleteButton: "Delete",
  deleteConfirmTitle: "Delete Website",
  deleteConfirmDescription: 'Do you really want to delete "{title}"',
  deleteAdminNote: " This action can be undone.",
  delete: "Delete",
  websiteDeleted: '"{title}" was deleted',
  websiteUpdated: "Website successfully updated",
  suggestionsTitle: "Review Suggestions",
  suggestionsDesc:
    "Review suggestions from other users and decide on their inclusion",
  noSuggestions: "No open suggestions",
  suggestedBy: "Suggested by: {name} on {date}",
  approveButton: "Approve",
  editAndApproveButton: "Edit & Approve",
  rejectButton: "Reject",
  reject: "Reject",
  suggestionApproved: "Suggestion was approved",
  suggestionApprovedWithChanges: "Suggestion was approved with changes",
  suggestionRejected: "Suggestion was rejected",
  editWebsiteTitle: "Edit Website",
  editWebsiteDesc: "Update website details and save changes",
  editSuggestionTitle: "Edit Suggestion",
  editSuggestionDesc: "Make changes and approve the suggestion or save edits",
  titleField: "Title",
  urlField: "URL",
  descriptionField: "Description",
  mainCategoryField: "Main Category",
  subCategoryField: "Subcategory",
  search: "Search...",
  save: "Save",
  approveWithChanges: "Edit & Approve",
  saveSuggestionEdits: "Save Edits",
  suggestionSaved: "Suggestion was saved",
  successAddTitle: "Website successfully added!",
  successAddMessage:
    "The website has been successfully added to the archive and is immediately available.",
  website: "Website",
  category: "Category",
};

